import * as localforage from "localforage";
import { generateRecursiveList } from "../helpers/generateRecursiveList";
import { flatMultiDimensional } from "../helpers/flatMultiDimensional";
import _ from "lodash";
import { phpRequest } from "./phpRequest";

export const getCompanyTreeAPI = async (isAll, company_id, useParamId) => {
  if (!company_id || !useParamId) {
    company_id = await localforage.getItem("userCompanyID");
  }
  const data = await phpRequest.get(
    isAll ? "/company-tree" : "/sub-companies",
    {
      company_id,
    }
  );
  if (data && data.companies) {
    const companyTreeArr = generateRecursiveList(data.companies);
    const flattenSubCompaniesArr = flatMultiDimensional(data.companies);
    const flattenCompanyTreeWithoutHQ = _.reject(
      flattenSubCompaniesArr,
      function (o) {
        return !o.parent_company_id;
      }
    );
    await localforage.setItem("companyTree", companyTreeArr);
    await localforage.setItem("flattenCompanyTree", flattenSubCompaniesArr);
    await localforage.setItem(
      "flattenCompanyTreeWithoutHQ",
      flattenCompanyTreeWithoutHQ
    );
  }
};
